import React from "react";

// Slow editorial marquee. Duplicates content for seamless loop.
const Marquee = ({ words = [], className = "" }) => {
  const content = words.length ? words : ["Leadership", "Partnership", "Innovation", "Excellence"];
  return (
    <div className={`relative w-full overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap will-change-transform">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {content.map((w, i) => (
              <span key={`${dup}-${i}`} className="flex items-center">
                <span className="font-serif italic text-5xl md:text-7xl text-navy/90 px-8">
                  {w}
                </span>
                <span className="text-gold text-3xl md:text-4xl">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
